module.exports = __webpack_public_path__ + "img/success.de2321f7.jpg";